import React, { useEffect, useState } from "react";
import { bool, string } from "prop-types";

import resourcesAdImage from "../../../../../../app/assets/images/menu_resources/resources.png";
import { onComparablesReportsClick } from "../../utilities";
import {
  Column,
  Container,
  Dropdown,
  List,
  ListItem,
  ListItemLink,
  Title
} from "../MainNav/Dropdown";
import { useMainNavDropdown } from "../MainNav/hooks";
import { DEFAULT_DROPDOWN_TITLE } from "./constants";
import * as S from "./styled";

const ResourcesMainNavDropdown = ({
  has_comparables,
  has_openhouses,
  is_full_width,
  is_wide,
  signed_in,
  title
}) => {
  const [adImageProps, setAdImageProps] = useState({ src: "", srcSet: "" });
  const {
    dropdownRef,
    isActive,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = useMainNavDropdown({
    event_label: "Resourses",
    event_value: ""
  });
  const resourcesDataGtm = {
    "data-gtm-header-menu": "Resources"
  };
  useEffect(() => {
    setAdImageProps({
      src: resourcesAdImage,
      srcSet: `${resourcesAdImage} 2x`
    });
  }, []);
  return (
    <>
      <S.ResourcesDropdownButton
        ref={dropdownRef}
        aria-expanded={isActive}
        aria-haspopup="true"
        aria-label={DEFAULT_DROPDOWN_TITLE}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        title={title}
      >
        <Dropdown isActive={isActive} role="tooltip">
          <Container isFullWidth={!!is_full_width} isWide={!!is_wide}>
            <Column>
              <Title>Guides</Title>
              <List hasBottomPadding>
                <ListItem>
                  <ListItemLink href="/guides/" {...resourcesDataGtm}>
                    NYC Real Estate Guides
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/neighborhoods/" {...resourcesDataGtm}>
                    Neighborhood Guides
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/guides/moving-nyc/"
                    {...resourcesDataGtm}
                  >
                    Moving to NYC Guide
                  </ListItemLink>
                </ListItem>
              </List>
              <Title>Mortgage</Title>
              <List>
                <ListItem>
                  <ListItemLink
                    href="/nyc/mortgage_rates"
                    {...resourcesDataGtm}
                  >
                    Mortgage Rates
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/nyc/calculator/index"
                    {...resourcesDataGtm}
                  >
                    Mortgage Calculator
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column>
              <Title>Tools</Title>
              <List hasBottomPadding>
                <ListItem>
                  <ListItemLink href="/talk" {...resourcesDataGtm}>
                    StreetEasy Forums
                  </ListItemLink>
                </ListItem>
                {has_openhouses && signed_in ? (
                  <ListItem name="open_house_planner">
                    <ListItemLink
                      href="/nyc/open_house_planner"
                      {...resourcesDataGtm}
                    >
                      Open House Planner
                    </ListItemLink>
                  </ListItem>
                ) : null}
                {has_openhouses && !signed_in ? (
                  <ListItem name="open_house_planner">
                    <ListItemLink
                      data-gtm-login-required="true"
                      data-gtm-origin="open_house"
                      data-gtm-rendered-from="site_nav"
                      data-gtm-track="resources-menu"
                      data-modal-class="modal-signin"
                      data-modal-source="/nyc/user/register_dialog?return_to=%2Fnyc%2Fopen_house_planner&origin=open_house"
                      data-toggle="modal"
                      href="#"
                      {...resourcesDataGtm}
                    >
                      Open House Planner
                    </ListItemLink>
                  </ListItem>
                ) : null}
                <ListItem>
                  <ListItemLink href="/blog/industry-hub" {...resourcesDataGtm}>
                    Industry Hub
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="https://streeteasy.com/blog/data-dashboard/">
                    Data Dashboard
                  </ListItemLink>
                </ListItem>
              </List>
              <Title>Market Data</Title>
              <List>
                <ListItem>
                  <ListItemLink
                    href="/blog/market-reports"
                    {...resourcesDataGtm}
                  >
                    Market Reports
                  </ListItemLink>
                </ListItem>
                {has_comparables && signed_in ? (
                  <ListItem>
                    <ListItemLink href="/my/comparables" {...resourcesDataGtm}>
                      Comparables Reports
                    </ListItemLink>
                  </ListItem>
                ) : null}
                {has_comparables && !signed_in ? (
                  <ListItem>
                    <ListItemLink
                      data-gtm-login-required="true"
                      data-gtm-origin="comparables_report"
                      data-gtm-rendered-from="site_nav"
                      data-gtm-track="resources-menu"
                      data-modal-class="modal-signin"
                      href="#"
                      onClick={onComparablesReportsClick}
                      {...resourcesDataGtm}
                    >
                      Comparables Reports
                    </ListItemLink>
                  </ListItem>
                ) : null}
              </List>
            </Column>
            <Column isLastShort>
              <Title>Q&A</Title>
              <List>
                <ListItem>
                  <ListItemLink
                    href="//streeteasy.com/guides/buyers-guide/should-you-rent-or-buy/"
                    {...resourcesDataGtm}
                  >
                    Should You Rent or Buy?
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="//streeteasy.com/guides/buyers-guide/what-are-maintenance-fees/"
                    {...resourcesDataGtm}
                  >
                    What are Maintenance Fees
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="//streeteasy.com/guides/renters-guide/how-much-rent-can-you-afford/"
                    {...resourcesDataGtm}
                  >
                    How Much Rent Can You Afford?
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="//streeteasy.com/guides/renters-guide/how-to-find-a-roommate-in-nyc/"
                    {...resourcesDataGtm}
                  >
                    How to Find a Roommate
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column isAdsShort>
              <ListItemLink
                data-gtm-header-menu="Resources"
                data-gtm-header-resource-ad="true"
                href="/my/comparables"
              >
                <img
                  alt="How to Buy, Rent, or Sell in NYC"
                  loading="lazy"
                  {...adImageProps}
                  {...resourcesDataGtm}
                />
              </ListItemLink>
            </Column>
          </Container>
        </Dropdown>
      </S.ResourcesDropdownButton>
    </>
  );
};

ResourcesMainNavDropdown.propTypes = {
  is_wide: bool,
  is_full_width: bool,
  signed_in: bool,
  has_comparables: bool,
  has_openhouses: bool,
  title: string
};

ResourcesMainNavDropdown.defaultProps = {
  is_wide: false,
  is_full_width: false,
  signed_in: false,
  has_comparables: false,
  has_openhouses: false,
  title: DEFAULT_DROPDOWN_TITLE
};

export default ResourcesMainNavDropdown;
